// extracted by mini-css-extract-plugin
export default {"ImgPlusButtons":"ImgAndButtons_ImgPlusButtons__81u1w","Img":"ImgAndButtons_Img__lYssv","ButtonsContainer":"ImgAndButtons_ButtonsContainer__7tsvR"};